import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnderline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconUnderline"><Path d="M6.5 12V3H5V12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12V3H17.5V12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12Z" fill="currentColor"/><Path d="M19 21.5V20H5V21.5H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnderline;
